import FxxlCore from '@fxxl/core';

export class FxxlAddressAutocomplete {
    constructor() {
        this.baseUrl = '/json.php?service=addressautocomplete';
        this.cacheCheckCityZip = {};
        this.initAutocomplete();
    }

    initAutocomplete() {
        document.querySelectorAll('.js_addressautocomplete_div').forEach(element => {
            const currentSet = element.dataset.addressautocomplete_set;
            const currentRole = element.dataset.addressautocomplete_role;
            const cityInput = element.closest('form').querySelector(`div[data-addressautocomplete_set=${currentSet}][data-addressautocomplete_role=city] input`);
            const streetInput = element.closest('form').querySelector(`div[data-addressautocomplete_set=${currentSet}][data-addressautocomplete_role=street] input`);
            const zipInput = element.closest('form').querySelector(`div[data-addressautocomplete_set=${currentSet}][data-addressautocomplete_role=zip] input`);
            let landIso2 = '';

            if (currentSet === 'la' || currentSet === 'p') {
                let land = element.closest('form').querySelector(`div[data-addressautocomplete_set=${currentSet}][data-addressautocomplete_role=land] select`);
                if (land && (land.value === 'DE' || land.value === 'AT')) {
                    landIso2 = land.value;
                }

               if (landIso2 === '') {
                   land = element.closest('form').querySelector(`div[data-addressautocomplete_set=${currentSet}][data-addressautocomplete_role=land] input`);
                   if (land && (land.dataset.value === 'DE' || land.dataset.value === 'AT')) {
                       landIso2 = land.dataset.value;
                   }
               }
            }

            element.querySelectorAll('input').forEach(input => {
                $(input).devbridgeAutocomplete({
                    autoSelectFirst: true,
                    lookup: (query, callbackShow) => {
                        if (cityInput && zipInput) {
                            const city = cityInput.value || '';
                            const zip = zipInput.value || '';
                            if (currentRole === 'zip') {
                                this.autocompleteCityZip(landIso2, '', zip, callbackShow);
                            } else if (currentRole === 'city') {
                                this.autocompleteCityZip(landIso2, city, '', callbackShow);
                            } else if (currentRole === 'street') {
                                const street = streetInput.value || '';
                                this.autocompleteStreet(landIso2, city, zip, street, callbackShow);
                            }
                        }
                    },
                    minChars: 3,
                    onSelect: (suggestion) => {
                        if (cityInput && zipInput) {
                            if (currentRole === 'zip' || currentRole === 'city') {
                                if (suggestion.data && suggestion.data.city && suggestion.data.zip) {
                                    cityInput.value = suggestion.data.city + (suggestion.data.quarter ? `-${suggestion.data.quarter}` : '');
                                    zipInput.value = suggestion.data.zip;
                                    FxxlCore.eventEmitter('blur').emit(null, cityInput);
                                    FxxlCore.eventEmitter('blur').emit(null, zipInput);
                                    FxxlCore.eventEmitter('focus').emit(null, streetInput);
                                    cityInput.closest('.fxxl-element-formelement').classList.add('fxxl-text-input--active');
                                    zipInput.closest('.fxxl-element-formelement').classList.add('fxxl-text-input--active');
                                    this.reportSelect(suggestion.data.selectParams);
                                }
                            } else if (currentRole === 'street') {
                                if (suggestion.data && suggestion.data.street) {
                                    streetInput.value = suggestion.data.street;
                                }
                            }
                        }
                        FxxlCore.eventEmitter('blur').emit(null, element);
                        FxxlCore.eventEmitter('change').emit(null, element);
                    },
                    onInvalidateSelection: () => {
                        const timeoutId = setTimeout(() => {
                            clearTimeout(timeoutId);
                        }, 1000);
                    }
                });
            });
        });
    }

    getRequestUrl(addParams) {
        return FxxlCore.buildUrlWithParams(this.baseUrl, addParams);
    }

    getCachekey(zip, cityAndQuarter) {
        return `${zip}#${cityAndQuarter.trim().split(/[\s\-/.,]+/).join(' ')}`.toLowerCase();
    }

    autocompleteCityZip(land, city, zip, callback) {
        if (land.trim().length > 0 && (city.trim().length > 0 || zip.trim().length > 0)) {
            fetch(this.getRequestUrl({
                country: land,
                city: city,
                function: 'autocompleteCityZip',
                zip: zip
            }))
                .then(response => response.json())
                .then(data => {
                    if (typeof data === 'object' && data.success && data.resultset) {
                        const resultset = data.resultset.map(item => ({
                            data: item,
                            value: `${item.zip} ${item.city}${item.quarter ? `-${item.quarter}` : ''}`
                        }));

                        resultset.forEach(item => {
                            let cachekey = this.getCachekey(item.data.zip, `${item.data.city} ${item.data.quarter}`);
                            this.cacheCheckCityZip[cachekey] = true;
                            cachekey = this.getCachekey(item.data.zip, item.data.city);
                            this.cacheCheckCityZip[cachekey] = true;
                        });

                        callback({ suggestions: resultset });
                    }
                });
        }
    }

    autocompleteStreet(land, city, zip, street, callback) {
        if (land.trim().length > 0 && (city.trim().length > 0 || zip.trim().length > 0)) {
            fetch(this.getRequestUrl({
                country: land,
                city: city,
                function: 'autocompleteStreet',
                street: street,
                zip: zip
            }))
                .then(response => response.json())
                .then(data => {
                    if (typeof data === 'object' && data.success && data.resultset) {
                        const resultset = data.resultset.map(item => ({
                            data: item,
                            value: item.street
                        }));
                        callback({ suggestions: resultset });
                    }
                });
        }
    }

    checkCityZip(city, zip, callback) {
        if (city.trim().length > 0 && zip.match(/^\d{5}$/)) {
            if (typeof addressautocomplete_validation_level !== 'undefined' && addressautocomplete_validation_level > 0) {
                const requestCachekey = this.getCachekey(zip, city);
                if (this.cacheCheckCityZip.hasOwnProperty(requestCachekey)) {
                    callback(this.cacheCheckCityZip[requestCachekey]);
                } else {
                    fetch(this.getRequestUrl({
                        function: 'checkCityZip',
                        city: city,
                        zip: zip
                    }))
                        .then(response => response.json())
                        .then(data => {
                            let valid = true;
                            if (typeof data === 'object' && data.success && data.hasOwnProperty('valid')) {
                                valid = data.valid;
                                this.cacheCheckCityZip[requestCachekey] = valid;
                            }
                            callback(valid);
                        })
                        .catch(() => {
                            callback(true);
                        });
                }
            } else {
                callback(true);
            }
        } else {
            callback(false);
        }
    }

    reportSelect(selectParams) {
        fetch(this.getRequestUrl({
            function: 'reportSelect',
            selectParams: selectParams
        }), { dataType: 'json' });
    }
}